import Router from "vue-router";
const { isNavigationFailure } = Router;
const originalPush = Router.prototype.push;

export const suppressRouterNavigationErrors = router => {
    router.prototype.push = function (location, onResolve, onReject) {
        // Call normal push method if optional parameters are specified looking for promise to be resolved or rejected
        if (onResolve || onReject) {
            return originalPush.call(this, location, onResolve, onReject);
        }

        return originalPush.call(this, location).catch(error => {
            if (isNavigationFailure(error)) {
                return Promise.resolve(error.from);
            }

            return Promise.reject(error);
        });
    };
};